import { useFormContext } from './FormContext';
import { Facility, FormData } from './types';

export function validateFacilityInfo(
  facility: Facility,
  formData: FormData,
  section?: 'facility-info' | 'contact-info' | 'billing-info',
) {
  const errors: Record<string, string> = {};
  const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  if (!section || section === 'facility-info') {
    // Business Info
    if (!facility.businessInfo.facilityName && !formData.businessInfo.facilityName) errors.facilityName = 'Facility name is required';
    if (!facility.businessInfo.address && !formData.businessInfo.address) errors.facilityAddress = 'Address is required';
    if (!facility.businessInfo.city && !formData.businessInfo.city) errors.facilityCity = 'City is required';
    if (!facility.businessInfo.state && !formData.businessInfo.state) errors.facilityState = 'State is required';
    if (!facility.businessInfo.zip && !formData.businessInfo.zip) errors.facilityZip = 'ZIP code is required';
    if (!facility.shippingInfo?.deliveryOption?.id || !facility.shippingInfo?.deliveryOption)
      errors.facilityDeliveryOption = 'Delivery option is required';
  }

  if (!section || section === 'contact-info') {
    // Shipping Contact
    const shippingContact = facility.shippingInfo.contact;
    if (!shippingContact?.firstName && !formData.shippingInfo.contact.firstName) errors.shippingContactFirstName = 'First name is required';
    if (!shippingContact?.lastName && !formData.shippingInfo.contact.lastName) errors.shippingContactLastName = 'Last name is required';
    if ((!shippingContact?.email || !isValidEmail(shippingContact?.email)) && !formData.shippingInfo.contact.email) errors.shippingContactEmail = 'Email is required';
    if (!shippingContact?.phone && !formData.shippingInfo.contact.phone) errors.shippingContactPhone = 'Phone is required';
  }

  if (!section || section === 'billing-info') {
     // Billing Info
    if ((!facility.billingInfo.address && !facility.billingInfo.sameAsCorporate) && !formData.billingInfo.address) errors.facilityBillingAddress = 'Address is required';
    if ((!facility.billingInfo.city && !facility.billingInfo.sameAsCorporate) && !formData.billingInfo.city) errors.facilityBillingCity = 'City is required';
    if ((!facility.billingInfo.state && !facility.billingInfo.sameAsCorporate) && !formData.billingInfo.state) errors.facilityBillingState = 'State is required';
    if ((!facility.billingInfo.zip && !facility.billingInfo.sameAsCorporate) && !formData.billingInfo.zip) errors.facilityBillingZip = 'ZIP code is required';
    // Billing Contact
    const billingContact = facility.billingInfo.contact;
    if (!billingContact?.firstName && !formData.billingInfo.contact.firstName) errors.billingContactFirstName = 'First name is required';
    if (!billingContact?.lastName && !formData.billingInfo.contact.lastName) errors.billingContactLastName = 'Last name is required';
    if ((!billingContact?.email || !isValidEmail(billingContact?.email)) && !formData.billingInfo.contact.email) errors.billingContactEmail = 'Email is required';
    if (!billingContact?.phone && !formData.billingInfo.contact.phone) errors.billingContactPhone = 'Phone is required';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}